import { DashboardPage } from '@/components/DashboardPage';
import { chooseCardSite } from '@/features/builder/lib/cardSiteChoice';
import { createFileRoute, getRouteApi } from '@tanstack/react-router'
import { useEffect } from 'react';
import { z } from 'zod';

// `?view=card` opens the card dashboard for an owner who also has a builder site (see `_protected`).
const searchSchema = z.object({
  view: z.enum(['card']).optional().catch(undefined),
});

export const Route = createFileRoute('/_protected/_site/')({
  validateSearch: searchSchema,
  component: Index,
})

function Index() {
  const routeApi = getRouteApi("/_protected/_site")
  const data = routeApi.useLoaderData()
  const { view } = Route.useSearch()

  useEffect(() => {
    if (view === 'card') chooseCardSite()
  }, [view])

  return (
    <DashboardPage site={data} />
  )
}
